<template lang="pug">

    .item
        .content

            .header
                | {{ supplierModel.name }}

            .description
                i.large.icons(
                    v-for='[ variantModel, offerModel ] in variantOfferModelTuples'
                )
                    //- Varianten-Nummer
                    .ui.tiny.label(
                        v-bind:class="{ disabled: offerModel === undefined }"
                    ) V{{ variantModel.number }}

                    //- Wurde vom Lieferanten abgelehnt
                    i.corner.red.remove.circle.icon(v-if="offerModel !== undefined && isDeclined(offerModel)")

                    //- Lieferant hat Preis eingegeben
                    i.corner.green.check.circle.icon(v-if="offerModel !== undefined && hasPrice(offerModel)")

</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
    import * as R from 'ramda'

    export default {

        computed: {

            variantOfferModelTuples() {
                return R.compose(

                    // Tupel aus Varianten und Angeboten erstellen => [Variante, Angebot]
                    R.zip(this.variantModels),

                    // Angebote zur Varianten-ID finden
                    R.map(variantId => R.find(R.propEq('variant', variantId), this.offerModels)),

                    // ID der Varianten auslesen
                    R.map(R.prop('id'))

                )(this.variantModels)
            }

        },

        methods: {

            hasPrice(offerModel) {
                return offerModel.status === 'PENDING' && R.is(String, offerModel.validUntilBySupplier)
            },

            isDeclined(offerModel) {
                return offerModel.status === 'DECLINED'
            },

        },

        props: {

            jobModel: {
                type: Object,
                required: true
            },

            offerModels: {
                type: Array,
                required: true
            },

            supplierModel: {
                type: Object,
                required: true
            },

            variantModels: {
                type: Array,
                required: true
            },

        }

    }

</script>

<!--suppress CssUnusedSymbol -->
<style scoped>

    .large.icons {
        width: 35px;
    }

    .corner.circle.icon {
        margin: 15px 2px;
    }


</style>
